import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getMatchupState } from '../store/selectors/matchupSelector';
import Matchup from '../Matchup';
import matchupReducer from '../store/reducers/matchup';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import { useMedia } from '@mlb/react-patterns/utils/hooks/useMedia/useMedia';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

// register our reducers for the data container
initContainerData.register({
    reducers: { matchup: matchupReducer }
});

const { XS_MAX } = GDBREAKPOINTS;

const MatchupDataContainer = (props) => {
    const { gameStateOverride, type, ...otherProps } = props;
    const matchupState = useSelector(getMatchupState);
    const isMobile = useMedia({ maxWidth: `${XS_MAX}` });
    return (
        <ErrorBoundaryWrapper componentName='Matchup' horizontal={gameStateOverride !== 'P' && !isMobile} width={48}>
            <Matchup type={type} {...matchupState} gameStateOverride={gameStateOverride} {...otherProps} />
        </ErrorBoundaryWrapper>
    );
};

MatchupDataContainer.propTypes = {
    inningState: PropTypes.string,
    gameStateOverride: PropTypes.string
};

export default MatchupDataContainer;
